import type { CorporatePageApiModel } from '@gro-up/api/corporate'

export const fetchGeocoding = async (query: string): Promise<{ latitude: number; longitude: number }> => {
  return $fetch(`/api/geocoding?query=${query}`)
}

export const fetchPage = (url: string): Promise<CorporatePageApiModel> => {
  return $fetch<CorporatePageApiModel>(`/api/content${url === '/' ? '/index' : url}`)
}
